import React from 'react';
import { Link } from 'react-router-dom';

function Settings() {
    return (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <h1 className="text-2xl font-bold text-slate-800 mb-6">Settings</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <Link to="/firms" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-indigo-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Firms</h3>
                    <p className="text-sm text-slate-500">Manage your organizations</p>
                </Link>

                <Link to="/settings/modules" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-green-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Modules</h3>
                    <p className="text-sm text-slate-500">Enable/disable features</p>
                </Link>

                <Link to="/settings/roles" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-purple-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Roles & Permissions</h3>
                    <p className="text-sm text-slate-500">Manage user access</p>
                </Link>

                <Link to="/staff" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-blue-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Staff</h3>
                    <p className="text-sm text-slate-500">Manage team members</p>
                </Link>

                <Link to="/settings/product-fields" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-amber-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Product Fields</h3>
                    <p className="text-sm text-slate-500">Custom product attributes</p>
                </Link>
                <Link to="/settings/account" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-slate-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Account & Profile</h3>
                    <p className="text-sm text-slate-500">Manage personal settings</p>
                </Link>

                <Link to="/settings/tax-rates" className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-slate-200">
                    <div className="text-rose-600 mb-3">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">Tax Registry</h3>
                    <p className="text-sm text-slate-500">Configure GST slots & tax rates</p>
                </Link>

                <Link to="/settings/help/pos" className="bg-indigo-50 p-6 rounded-lg shadow hover:shadow-lg transition-shadow border border-indigo-200">
                    <div className="text-indigo-600 mb-3 font-black text-2xl">
                        ⌨️
                    </div>
                    <h3 className="font-semibold text-indigo-900 mb-1">POS Keyboard Shortcuts & Help</h3>
                    <p className="text-sm text-indigo-700/80">Documentation for global shortcuts & workflow guides</p>
                </Link>
            </div>
        </div>
    );
}

export default Settings;
